import AssessmentIcon from '@material-ui/icons/Assessment';
import {
  createFrontendPlugin,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import { rootRouteRef } from './routes';

// Every analytics page renders its own core-components Page/Header, so the
// framework header is off to avoid a second one. Moving to the framework/BUI
// header belongs to the MUI→BUI track. The page is mounted at `/analytics/*`,
// and AnalyticsPage keeps its drill-down <Routes> (catalog-info-adoption,
// ownership-rules).
const analyticsPage = PageBlueprint.make({
  params: {
    path: '/analytics',
    routeRef: rootRouteRef,
    noHeader: true,
    loader: () =>
      import('./components/AnalyticsPage/AnalyticsPage').then(m => (
        <m.AnalyticsPage />
      )),
  },
});

export default createFrontendPlugin({
  pluginId: 'analytics',
  title: 'Analytics',
  icon: <AssessmentIcon fontSize="inherit" />,
  info: { packageJson: () => import('../package.json') },
  routes: { root: rootRouteRef },
  extensions: [analyticsPage],
});
